import Model, { JsonObject } from 'src/models/model'

export default class Generic extends Model {
  static name = 'Generic'

  static noId = true

  static define () {
    this.fields = {
      value: {
        type: JsonObject,
        output: true
      }
    }
  }
}
